export default class mobileMenuCtrl {
    constructor($scope, $http, $rootScope, $compile) {
        'ngInject';
        accountScope = angular.element(document.getElementById('account-wrap')).scope();
        $scope.registerUserMobile = function () {
            angular.element(document.getElementById('account-wrap')).scope().registerUserOpen();
        }
    }
}